import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { UserModuleOutput } from '../model/user-module.output';

export interface UpdateUserModuleRatingInput {
	readonly moduleRatingComment: string;
	readonly moduleRatingValue: number;
	readonly moduleId: string;
	readonly userId: string;
}

export interface UpdateUserModuleRatingParams {
	input: UpdateUserModuleRatingInput;
}

@Injectable({ providedIn: 'root' })
export class UpdateUserModuleRatingApiMutation extends ApiMutation<
	UserModuleOutput,
	UpdateUserModuleRatingParams
> {
	client = 'content';
	document = gql`
		mutation UpdateUserModuleRating($input: UpdateUserModuleRatingInput!) {
			updateUserModuleRating(input: $input) {
				id
				isDone
				userId
				moduleId
				isStarted
				coachComment
				updateTimestamp
				moduleRatingValue
				moduleRatingComment
				module {
					id
				}
				pages {
					pageId
					activityUrl
					id
				}
			}
		}
	`;
	method = 'updateUserModuleRating';
}
